import Navigation from "../components/Navigation";
import Seo from "../components/Seo";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { BookOpen, ArrowUpRight } from "lucide-react";

// Autoritäts-/Autorenseite. Deutsch hardcoded (prerendert = indexiert).
// Bücher + verifizierte Händler-/Profil-Links (Amazon, Goodreads, Waterstones, Books-A-Million).

const TITLE = "Bücher von Daaniyal Khan – KI, Vertrieb, Marketing & Finanzen";
const DESCRIPTION =
  "Daaniyal Khan ist Autor mehrerer Bücher zu Künstlicher Intelligenz, Vertrieb, viralem Marketing und Finanzen — praxisnah aus über einem Jahrzehnt Finanz- und Versicherungsvertrieb. Weltweit erhältlich bei Amazon, Goodreads, Waterstones und Books-A-Million.";

const BOOKS = [
  {
    title:
      "Künstliche Intelligenz & ChatGPT – der Einsatz im Versicherungsvertrieb",
    topic:
      "Von Chatbots bis Machine Learning: wie KI den Versicherungsvertrieb konkret verändert.",
    url: "https://www.amazon.de/dp/B0BTGKRW19",
  },
  {
    title: "Virales Marketing – Trends erkennen und nutzen",
    topic:
      "Wie Trends entstehen, wie man sie früh erkennt und für Wachstum nutzt.",
    url: "https://www.amazon.de/dp/B0BLYBDGGC",
  },
  {
    title: "Die wichtigen Schritte zum Influencer",
    topic: "Reichweite und Personenmarke aufbauen — Schritt für Schritt.",
    url: null,
  },
  {
    title: "Die Börsenintelligenz – Die raffinierte Kunst des erfolgreichen Aktienhandels",
    topic: "Strategien und Denkweisen für erfolgreichen Aktienhandel.",
    url: null,
  },
  {
    title: "Weisheiten des Geldes",
    topic:
      "Finanzielle Prinzipien und Denkweisen für nachhaltigen Vermögensaufbau.",
    url: null,
  },
  {
    title: "Die wichtigsten Regeln und Wege zum Erfolg – Prinzipien und Leitsätze",
    topic: "Leitsätze für nachhaltigen unternehmerischen und persönlichen Erfolg.",
    url: null,
  },
  {
    title: "The main rules and paths to success – Principles and guidelines",
    topic: "Principles and guidelines for lasting success (English Edition).",
    url: null,
  },
  {
    title: "Ziele richtig setzen und erreichen",
    topic: "Ziele klar definieren und konsequent umsetzen.",
    url: null,
  },
  {
    title: "Setting realistic goals and achieving them",
    topic: "Set realistic goals and follow through (English Edition).",
    url: null,
  },
  {
    title: "Finde die richtige Nische – Schritt für Schritt Anleitung",
    topic: "Die passende Nische systematisch finden und besetzen.",
    url: null,
  },
  {
    title: "How to find your niche – step-by-step guide",
    topic: "Find and own the right niche, step by step (English Edition).",
    url: null,
  },
  {
    title: "Evolution der Motivation",
    topic:
      "Wie evolutionäre Mechanismen unser Denken und Handeln prägen.",
    url: null,
  },
];

const RETAILERS = [
  {
    name: "Amazon (Autorenseite)",
    url: "https://www.amazon.de/stores/author/B0BPJNFFH8",
  },
  {
    name: "Goodreads",
    url: "https://www.goodreads.com/author/show/23095926.Daaniyal_Khan",
  },
  {
    name: "Waterstones",
    url: "https://www.waterstones.com/books/search/term/daaniyal+khan",
  },
  {
    name: "Books-A-Million",
    url: "https://www.booksamillion.com/search?query=Daaniyal+Khan&filters[authors]=Daaniyal+Khan",
  },
];

const bookSchema = BOOKS.map((b) => ({
  "@context": "https://schema.org",
  "@type": "Book",
  name: b.title,
  inLanguage: "de",
  author: {
    "@type": "Person",
    name: "Daaniyal Khan",
    url: "https://www.daaniyalkhan.com",
  },
  ...(b.url ? { url: b.url } : {}),
}));

const Buecher = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Seo title={TITLE} description={DESCRIPTION} />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-50 focus:bg-[#C5A66A] focus:text-[#0F1B2D] focus:px-4 focus:py-2 focus:rounded focus:font-semibold"
      >
        Zum Hauptinhalt springen
      </a>
      <Navigation />
      <main id="main-content" className="pt-32 pb-20">
        <div className="container mx-auto px-6 max-w-4xl">
          <header className="mb-12 max-w-3xl">
            <div className="text-sm text-[#C5A66A] uppercase tracking-wider font-semibold mb-4">
              Autor &amp; Bücher
            </div>
            <h1 className="font-playfair text-4xl lg:text-6xl font-bold text-[#0F1B2D] mb-6 leading-tight">
              Bücher von Daaniyal Khan
            </h1>
            <p className="text-xl text-gray-700 leading-relaxed">
              Neben der Beratung schreibe ich. Über ein Dutzend Titel zu
              Künstlicher Intelligenz, Vertrieb, Marketing, Finanzen und
              Persönlichkeitsentwicklung — verdichtet aus über einem Jahrzehnt im
              Finanz- und Versicherungsumfeld, von GenAI im Vertrieb über virales
              Marketing bis zu Aktienhandel und Geld-Prinzipien. International
              erhältlich, mit Leserinnen und Lesern auch in Asien und Südamerika.
            </p>
          </header>

          {/* Bücher */}
          <section className="mb-16 grid gap-6 md:grid-cols-2">
            {BOOKS.map((b) => {
              const inner = (
                <>
                  <div className="w-12 h-12 rounded-xl bg-[#C5A66A]/10 flex items-center justify-center mb-4">
                    <BookOpen
                      size={24}
                      className="text-[#C5A66A]"
                      aria-hidden="true"
                    />
                  </div>
                  <h2 className="font-bold text-lg text-[#0F1B2D] mb-2 leading-snug">
                    {b.title}
                  </h2>
                  <p className="text-gray-600 leading-relaxed flex-grow">
                    {b.topic}
                  </p>
                  {b.url && (
                    <div className="mt-4 flex items-center font-semibold text-[#0F1B2D] group-hover:text-[#C5A66A] transition-colors">
                      Bei Amazon ansehen
                      <ArrowUpRight
                        size={18}
                        className="ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                      />
                    </div>
                  )}
                </>
              );
              return b.url ? (
                <a
                  key={b.title}
                  href={b.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group flex flex-col h-full bg-white rounded-2xl border border-gray-200 hover:border-[#C5A66A] hover:shadow-xl hover:-translate-y-1 transition-all duration-300 p-7"
                >
                  {inner}
                </a>
              ) : (
                <div
                  key={b.title}
                  className="flex flex-col h-full bg-[#FAFAF8] rounded-2xl border border-gray-200 p-7"
                >
                  {inner}
                </div>
              );
            })}
          </section>

          {/* Wo erhältlich */}
          <section className="mb-16">
            <h2 className="font-playfair text-3xl font-bold text-[#0F1B2D] mb-6">
              Weltweit erhältlich
            </h2>
            <div className="flex flex-wrap gap-4">
              {RETAILERS.map((r) => (
                <a
                  key={r.name}
                  href={r.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-5 py-3 rounded-lg font-semibold text-[#0F1B2D] border border-gray-300 hover:border-[#C5A66A] hover:text-[#C5A66A] transition-colors"
                >
                  {r.name}
                  <ArrowUpRight size={16} className="ml-1.5" />
                </a>
              ))}
            </div>
          </section>

          {/* CTA */}
          <section className="bg-gradient-to-r from-[#0F1B2D] to-[#1a2d4a] rounded-2xl p-10 text-white text-center">
            <h2 className="text-3xl font-bold mb-4 text-[#C5A66A]">
              Die Themen in der Praxis
            </h2>
            <p className="text-lg mb-8 max-w-2xl mx-auto">
              Was in den Büchern steht, setze ich mit Unternehmen um — KI im
              Vertrieb, Digitalisierung und Strategie.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <Link
                to="/ki-vertrieb"
                className="inline-block bg-[#C5A66A] text-[#0F1B2D] px-8 py-4 rounded-lg font-semibold hover:bg-[#b8966b] hover:scale-105 transition-all duration-300"
              >
                KI im Vertrieb
              </Link>
              <Link
                to="/#contact"
                className="inline-block px-8 py-4 rounded-lg font-semibold text-white border border-white/30 hover:border-[#C5A66A] hover:text-[#C5A66A] transition-colors"
              >
                Kontakt
              </Link>
            </div>
          </section>
        </div>
      </main>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(bookSchema) }}
      />
    </div>
  );
};

export default Buecher;
